// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1786019127666
      var cssReload = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../","locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  